/**
 * Program: validation directive
 * Author: SDL
 * Description: validation directive
 */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
import SDLUtil from '@/utils/SDLUtil';

const showErrMsg = (field, msg) => {
    const errDiv = document.createElement('em');

    errDiv.innerHTML = SDLUtil.getMsgProp(msg);
    errDiv.className = 'warning_msg';
    field.classList.add('warning');
    field.insertAdjacentElement('afterend', errDiv);
};

const validationObj = (field, valids) => {
    Array.from(field.parentElement.querySelectorAll('.warning_msg')).map(el => {
        try {
            el.remove();
        } catch (e) {
            el.parentNode.removeChild(el);
        }
    });

    if (field.willValidate && !field.checkValidity()) {
        let errMsg = field.validationMessage;
        if (field.getAttribute('errorMessage')) errMsg = field.getAttribute('errorMessage');

        showErrMsg(field, errMsg);

    } else if (valids.length > 0) {
        for (let i = 0; i < valids.length; i += 1) {
            if (!valids[i].validFuncs()) {
                showErrMsg(field, valids[i].errorMessage);
                break;
            }
        }
    }
};

export default {
    bind(el, binding, vnode) {
        let groupId = '';
        let valids = [];
        if (binding.value && Object.prototype.hasOwnProperty.call(binding.value, 'groupId')) {
            groupId = binding.value.groupId;
        }

        if (binding.value && Object.prototype.hasOwnProperty.call(binding.value, 'valids')) {
            valids = binding.value.valids;
        }

        SDLUtil.setValidList({ el, groupId });

        el.setAttribute('required', 'required');
        el.addEventListener('blur', e => {
            e.preventDefault();

            Array.from(document.querySelectorAll('.warning')).map(ele => ele.classList.remove('warning'));
            validationObj(el, valids);
        });

        el.addEventListener('focus', e => {
            e.preventDefault();

            el.classList.remove('warning');
        });
    },
    unbind(el, binding, vnode) {
        let groupId = '';
        if (binding.value && Object.prototype.hasOwnProperty.call(binding.value, 'groupId')) {
            groupId = binding.value.groupId;
        }
        SDLUtil.deleteValidList(el, groupId);
    },
};



// WEBPACK FOOTER //
// ./src/directives/validation.js